import { render, staticRenderFns } from "./ProfileTable.vue?vue&type=template&id=45ae691d&scoped=true"
import script from "./ProfileTable.vue?vue&type=script&lang=js"
export * from "./ProfileTable.vue?vue&type=script&lang=js"
import style0 from "./ProfileTable.vue?vue&type=style&index=0&id=45ae691d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae691d",
  null
  
)

export default component.exports